import { useQuery } from '@tanstack/react-query';
import { brand as fallback, type Brand } from '@marshal/brand';
import { publicGet } from './publicFetch';

/**
 * Fetch the brand from the API at runtime, so a brand swap (Marshal → final
 * committee pick) doesn't require a client rebuild.
 *
 * Falls back to the bundled brand if the API isn't reachable yet.
 */
export function useBrand(): Brand {
  const { data } = useQuery({
    queryKey: ['brand'],
    queryFn: () => publicGet<Brand>('/brand'),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
    placeholderData: fallback,
  });

  // Apply primary colour to a CSS variable so Tailwind utility classes
  // bound to var(--brand-primary) automatically respect the live brand.
  if (data?.primaryColor && typeof document !== 'undefined') {
    document.documentElement.style.setProperty('--brand-primary', data.primaryColor);
  }

  return data ?? fallback;
}
